import React from 'react'
import classNames from 'classnames'

import './Button.scss'

interface Props extends React.HTMLProps<HTMLButtonElement> {
    variant?: 'default' | 'primary' | 'round',
    full?: boolean,
    loading?: boolean,
    disable?: boolean,
}

export default class Button extends React.Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    public render() {

        const { variant, loading, full, children, disable, className, ...rest } = this.props

        const btnClasses = classNames( className, {
            'button': true,
            'button--default': !variant || variant === 'default',
            'button--primary': variant === 'primary',
            'button--round': variant === 'round',
            'button--loading': loading,
            'button--block': full
        })

        return (
            <button className={btnClasses} disabled={disable} {...rest}>{children}</button>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.tsx